import DefaultApiService from "./default";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectContractAcceptanceApi = {
  getPendingContracts: async () => {
    const res = await DefaultApiService.getCustomeApi(
      "SLN/Contractor/ProjectContractAcceptance/GetPendingContracts"
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  acceptContract: async (projectContractId) => {
    const res = await DefaultApiService.postApi(
      "SLN/Contractor/ProjectContractAcceptance/Accept",
      { projectContractId }
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectContractAcceptanceApi;
